<div class="mt-5 pt-5 mx-3 mx-md-5">
  <div class="row">
    <p-galleria
      [value]="images"
      [responsiveOptions]="responsiveOptions"
      [numVisible]="5"
      class="col-12 col-md-7"
    >
      <ng-template pTemplate="item" let-item>
        <img [src]="item" class="main-image" />
      </ng-template>

      <ng-template pTemplate="thumbnail" let-item>
        <div class="thumbnail-container">
          <img [src]="item" class="thumbnail" />
        </div>
      </ng-template>
    </p-galleria>

    <div class="col-12 col-md-5 px-3 mt-3 mt-md-0">
      <h1 class="name">product Name</h1>
      <h5 class="description">
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
      </h5>
      <p-rating [ngModel]="3.5" [readonly]="true" [cancel]="false" />
      <div class="d-flex align-items-center my-2">
        <h5 class="title">price:</h5>
        <h5 class="mx-2">150EGP</h5>
        <del>200EGP</del>
      </div>
      <div class="my-2">
        <h5 class="title">Color:</h5>
        <div class="d-flex flex-wrap">
          <div
            class="outer-circle"
            *ngFor="let color of colors"
            (click)="selectedColor = color"
            [ngClass]="{ 'color-active': selectedColor === color }"
          >
            <div class="inner-circle" [ngStyle]="{ background: color }"></div>
          </div>
        </div>
      </div>
      <h5 class="title">Size:</h5>
      <div class="d-flex flex-wrap my-3">
        <div
          class="size-card"
          *ngFor="let size of sizes"
          [ngClass]="{ 'size-card-selected': selectedSize === size }"
          (click)="selectedSize = size"
        >
          {{ size }}
        </div>
      </div>
      <div class="text-center mb-4">
        <button class="btn">Add To Card</button>
      </div>

      <p-accordion>
        <p-accordionTab header="Details"> </p-accordionTab>
      </p-accordion>
    </div>
  </div>
</div>
